import React from "react";
import styled from "styled-components";
import colors from "../config/colors";

const Paragraph = styled.p`
  font-size: ${({ small }) => (small ? "0.8rem" : "1.1rem")};
  line-height: 1.7;
  margin: 0;
  color: ${({ color }) => (color ? colors[color] : colors.text)};
`;

export default Paragraph;



// WEBPACK FOOTER //
// ./src/components/Paragraph.js